/**
 * Interactive Map Module for Value Retail Digital
 *
 * @version 1.0.0
 * @authors
 * 		Jaime DeFederico <jaime.defederico@iris-worldwide.com>
 * 		Rich Nelson <info@rich-nelson.co.uk>
*/


var InteractiveMap = (function( $ ) {


	/* * * * * PRIVATE * * * * */
	// Declare properties and methods that should be
	// private to the object.

	/* ----- VARS ----- */
	var $categoriesSelect;
	var $controls;
	var $mapplic;
	var $offersEvents;
	var $newStores;
	var $foodDrink;
/////////////////////////////////////////////
	var $location;

	var $search;
	var $searchInput;
	var $searchCancel;
	var $window;

	var __map;

	var __brands;
	var __categories;
	var __foods;
	var __locations;

	var __isTouch;
	var __mqMedium;

	var __searchTimer;
    var __newCategory;
    var __minNewStores;

	/* ----- CONSTANTS ----- */
	// var LOCATION_TYPE_FOOD = 'food';

	var MEDIA_QUERY_MEDIUM = "screen and ( min-width: 50.0625em )";

	var SELECTOR_CATEGORIES = "#map-categories";
	var SELECTOR_CONTROLS = "#map-controls";
	var SELECTOR_MAPPLIC = "#mapplic";
	// var SELECTOR_OFFERS = "#map-offers button";
	var SELECTOR_OFFERS_EVENTS = "#map-offers-events, #map-offers-events-small";
	var SELECTOR_NEW_STORES = "#map-new-stores, #map-new-stores-small";
	var SELECTOR_FOOD_DRINK = "#map-food-drink, #map-food-drink-small";
	var SELECTOR_LOCATION = "#map-location";

	var SELECTOR_SEARCH = "#map-search";
	var SELECTOR_SEARCH_CANCEL = "#map-search__cancel";

	var STYLE_ACTIVE = "active";
	var STYLE_EMPTY = "map-search--empty";
	var STYLE_SEARCH_FOCUS = "map-controls--search-focus";
	var STYLE_SELECT_HIDDEN = "select-hidden";
	var STYLE_SELECT_WRAPPER = "select-wrapper";

	var TIMEOUT_SEARCH = 1000;


	/* ----- FUNCTIONS ----- */
	function __init() {
		// console.log( "InteractiveMap: __init" );

		$mapplic = $( SELECTOR_MAPPLIC );
		$window = $( window );

		if ( $mapplic.length > 0 ) {

			__isTouch = ( document.ontouchstart !== undefined );

			__mqMedium = matchMedia( MEDIA_QUERY_MEDIUM );
			__mqMedium.addListener( __onMediumMediaQueryChange );

			__addMapplic();

		}

	}

	function __addCategories() {
		// console.log( "InteractiveMap: __addCategories" );

		if ( __categories && __categories.length > 0 ) {

			var $categories = $( SELECTOR_CATEGORIES );
			$categoriesSelect = $categories.find( "select" );
			$categoriesSelect.prop( "disabled", false );

			var $option;

			$.each( __categories, function( i, category ) {

				$option = $(
					'<option value="' + category + '">' + category + '</option>'
				);

				$option.appendTo( $categoriesSelect );

			} );

			//$categories.addClass( STYLE_SELECT_WRAPPER );

			if ( !__isTouch ) {

				$categoriesSelect.dropkick();
				$categoriesSelect.addClass( STYLE_SELECT_HIDDEN );

			}


			// Add Event Listeners
			$categoriesSelect.on( "change", __onCategoryChange );

		}

	}

	function __addControls() {
		// console.log( "InteractiveMap: __addControls" );

		$controls = $( SELECTOR_CONTROLS );

	}

	function __addMapplic() {
		var source= $mapplic.data( "api-controller-url" ) + "?" + $mapplic.data( "language-parameter-name" ) + "=" + $mapplic.data( "language-node-id" );
		//enable if testing locally

		// LOAD MAP FROM QA3 WHEN RUNNING FROM LOCAL
		// if ( window.location.href.indexOf('localhost')!=-1 ) {
		// 	source= "https://vrdigital-core-qa3.azurewebsites.net/Umbraco/Api/VillageMapApi/GetVillageMap?languageNodeId=1057";
		// }

		// console	.log( "InteractiveMap: __addMapplic" );
		// Debug/Developer
		var debug = __getParameterByName( "debug" ) === "true";

		// Get DisplayMode
		var displayMode = ( __mqMedium.matches ) ? 1 : 0;
		// Instantiate Mapplic on Container
		$mapplic.mapplic( {
			debug: debug,
			displayMode: displayMode,
			maxscale: 3,
			source: source
		} );

		// Add Listeners
		$mapplic.on( "load.mapplic.data", __onMapData );
		$mapplic.on( "close.mapplic.location", __onMapLocationClose );
		$mapplic.on( "open.mapplic.location", __onMapLocationOpen );
		$mapplic.on( "ready.mapplic.map", __onMapReady );
		$mapplic.on( "link.mapplic.tooltip", __onMapTooltipLink );
	}

	function __addOffersEvents() {
		// console.log( "InteractiveMap: __addOffersEvents" );

		$offersEvents = $( SELECTOR_OFFERS_EVENTS );
		$offersEvents.prop( "disabled", false );
		$offersEvents.on( "click", __onOffersEventsClick );
	}

    function __showHideOffersAndNewStoresButtons() {
        if (__locations && __locations.length > 0) {

            $offersEvents = $(SELECTOR_OFFERS_EVENTS);
            $newStores = $(SELECTOR_NEW_STORES);
            $foodDrink = $(SELECTOR_FOOD_DRINK);

            var mapHasNewStores = __locations.filter(function (a) {
                return a.categories.includes(__newCategory);
            }).length >= __minNewStores;

            var mapHasOffers = __locations.filter(function (a) {
                return a.offersAndEvents;
            }).length > 0;

            if (mapHasNewStores && mapHasOffers) {
                $foodDrink.removeClass('map-food-drink-single');
                $offersEvents.removeClass('hidden');
                $newStores.removeClass('hidden');
                __addOffersEvents();
                __addNewStores();
            } else if (mapHasNewStores) {
                $foodDrink.removeClass('map-food-drink-single');
                $newStores.removeClass('map-control-new-stores hidden')
                    .addClass('map-control-single');
                __addNewStores();
            } else if (mapHasOffers) {
                $foodDrink.removeClass('map-food-drink-single');
                $offersEvents.removeClass('map-control-offers-events hidden')
                    .addClass('map-control-single');
                __addOffersEvents();
            }
        }
	}
	
	function __addNewStores() {
		// console.log( "InteractiveMap: __addNewStores" );

		$newStores = $( SELECTOR_NEW_STORES );
		$newStores.prop( "disabled", false );
		$newStores.on( "click", __onNewStoresClick );

	}

	function __addFoodDrink() {
		// console.log( "InteractiveMap: __addFoodDrink" );

		$foodDrink = $( SELECTOR_FOOD_DRINK );
		$foodDrink.prop( "disabled", false );
		$foodDrink.on( "click", __onFoodDrinkClick );

	}

	function __addLocation(){
		$location = $( SELECTOR_LOCATION );
		$location.prop( "disabled", false );
		$location.on( "click", __onLocationClick );
	}

	function __addSearch() {
		// console.log( "InteractiveMap: __addSearch" );

		// Search
		$search = $( SELECTOR_SEARCH );
		$search.addClass( STYLE_EMPTY );

		$searchInput = $search.find( "input" );
		$searchInput.prop( "disabled", false );
		$searchInput.typeahead({
			hint: false,
			highlight: false,
			minLength: 1
		},
		{
			display: "title",
			limit: 12,
			name: "map",
			source: __searchSource( __foods, __locations ),
			templates: {
				suggestion: __searchSuggestion
			}
		});

		// Search Cancel
		$searchCancel = $( SELECTOR_SEARCH_CANCEL );
		$searchCancel.hide();

		// Add Event Listeners
		$searchInput.on( "typeahead:active", _onSearchActive );
		$searchInput.on( "typeahead:change", __onSearchChange );
		$searchInput.on( "typeahead:idle", __onSearchIdle );
		$searchInput.on( "typeahead:render", __onSearchRender );
		$searchInput.on( "typeahead:select", __onSearchSelect );
		$searchCancel.on( "click", __onSearchCancel );

	}

	function __categoryClear() {
		// console.log( "InteractiveMap: __categoryClear" );

		if ( $categoriesSelect ) {

			$categoriesSelect.dropkick( "reset", true );
			__map.clearHighlight();

		}

	}

	function __categoryHighlight( category ) {
		// console.log( "InteractiveMap: __categoryHighlight" );

		var exp = new RegExp( "," + category, "i" );

		var ary = __locations.filter( function( a ) {
			return exp.test( a.categories );
		} );

		ary = ary.map( function( a ) { return a.id; } );
		__map.toggleLocationHighlight( ary, true );

		__trackEvent( "map", "category-select", null, category );

	}

	function __getParameterByName( name ) {

		var url = window.location.href;

		name = name.replace( /[\[\]]/g, "\\$&" );
		var regex = new RegExp( "[?&]" + name + "(=([^&#]*)|&|#|$)" );
		var results = regex.exec( url );

		if ( !results )
			return null;

		if ( !results[ 2 ] )
			return "";

		return decodeURIComponent( results[ 2 ].replace( /\+/g, " " ) );

	}

	function __offersEventsClear() {
		// console.log( "InteractiveMap: __offersEventsClear" );

		$offersEvents.removeClass( STYLE_ACTIVE );
		__map.removePinHighlight();

	}

	function __offersEventsToggle() {
		// console.log( "InteractiveMap: __offersEventsToggle" );

		var isOffersEventsActive = $offersEvents.hasClass( STYLE_ACTIVE );

		var ary = __locations.filter( function( a ) {
			return a.offersAndEvents;
		} );

		var ary = ary.map( function( a ) { 
			return a.id;
		} );

		if ( isOffersEventsActive ) {

			__offersEventsClear();
			__map.toggleLocationHighlight( ary );

		} else {

			$offersEvents.addClass( STYLE_ACTIVE );
			__newStoresClear();

			__map.addPinHighlight( ary );
			__map.toggleLocationHighlight( ary, true );

		}

		__trackEvent( "map", "offersEvents-toggle", null, !isOffersEventsActive );

	}

	function __newStoresClear() {
		// console.log( "InteractiveMap: __newStoresClear" );

		$newStores.removeClass( STYLE_ACTIVE );
		__map.removePinHighlight();

	}

	function __newStoresToggle() {
		// console.log( "InteractiveMap: __newStoresToggle" );

		var isNewStoresActive = $newStores.hasClass( STYLE_ACTIVE );
		__offersEventsClear();

		if ( isNewStoresActive ) {

			__newStoresClear();

		} else {

			$newStores.addClass( STYLE_ACTIVE );

			var ary = __locations.filter( function( a ) {
                return a.categories.includes(__newCategory);
			} );

			var ary = ary.map( function( a ) { return a.id; } );

			__map.addPinHighlight( ary );

		}

		__trackEvent( "map", "newStores-toggle", null, !isNewStoresActive );

	}

	function __foodDrinkClear() {
		// console.log( "InteractiveMap: __foodDrinkClear" );

		$foodDrink.removeClass( STYLE_ACTIVE );
		__map.clearHighlight();

	}

	function __foodDrinkToggle() {
		// console.log( "InteractiveMap: __foodDrinkToggle" );

		var isfoodDrinkActive = $foodDrink.hasClass( STYLE_ACTIVE );

		if ( isfoodDrinkActive ) {

			__foodDrinkClear();

		} else {

			$foodDrink.addClass( STYLE_ACTIVE );

			var ary = __locations.filter( function( a ) {
				return a.type === 'food';
			} );

			var ary = ary.map( function( a ) { return a.id; } );

			__map.toggleLocationHighlight( ary, true );

		}

		__trackEvent( "map", "foodDrink-toggle", null, !isfoodDrinkActive );

	}


	function __processData( data ) {
		// console.log( "InteractiveMap: __processData" );

		// Locations
		var interactiveLocations = data.locations.filter( function( a ) { return a.interactive; } );

		__locations = interactiveLocations.map( function( a ) {

			return {
				id: a.id,
				categories: "," + a.categories.join( "," ),
				brands: "," + a.brands.join( "," ),
				type: ( a.type ),
				nonBrandUnit: ( a.nonBrandUnit ),
				title: a.details.title,
				image: a.details.image,
				offersAndEvents: ( a.details.offersAndEvents !== undefined ) && ( a.details.offersAndEvents !== "" ) && ( a.details.offersAndEvents.length )
			};
		} );

		// Brands
		//__brands = data.brands;

		// Categories
        __categories = data.categories;
        __newCategory = data.newCategory;
        __minNewStores = data.minNewStores <= 0 ? 1 : data.minNewStores;

		// Foods
		if ( data.foods )
			__foods = "," + data.foods.join( "," );

	}

	function __searchCancel() {
		// console.log( "InteractiveMap: __searchCancel" );

		$controls.removeClass( STYLE_SEARCH_FOCUS );
		$search.addClass( STYLE_EMPTY );
		$searchInput.typeahead( "val", "" );
		$searchCancel.hide();
		__map.hideLocation();
		__map.clearHighlight();

	}

	function __searchSource( foods, locations ) {
		// console.log( "InteractiveMap: __searchSource" );

		var strBrands = $searchInput.data( 'suggestion-brands' );
		var strFood = $searchInput.data( 'suggestion-food' );

		return function( query, callback ) {
			// console.log( "Search Callback", query );

			// Get Location Matches
			// NOTE: This is done using an object to
			// prevent adding duplicates.
			var exp = new RegExp( "(?:,)((a |the |el |le |la |l'|il |der |die |das )?" + query + "[^,]*)", "gi" );

			// Check for Food Match
			var foodMatch = exp.test( foods );

			var objLocationMatches = {};

			$.each( locations, function( i, location ) {

				var brandMatches = [];
				var brandMatch;

				while ( brandMatch = exp.exec( location.brands ) )
					brandMatches.push( brandMatch[ 1 ] );

				if ( location.brands && brandMatches.length > 0 ) {

					objLocationMatches[ location.id ] = {
						image: location.image,
						title: location.title
					};

					brandMatches = brandMatches.filter( function( a ) { return a.toLowerCase() !== location.title.toLowerCase(); } );

					if ( brandMatches.length > 0 )
						objLocationMatches[ location.id ].subtitle = strBrands + brandMatches.join( ", " );

				} else if ( location.type === "food" && foodMatch ) {

					objLocationMatches[ location.id ] = {
						image: location.image,
						title: location.title,
						subtitle: strFood
					};

				}

			} );


			// Convert Location Object to Array
			var aryLocationMatches = [];

			$.each( objLocationMatches, function( i, location ) {

				aryLocationMatches.push( {
					id: i,
					image: objLocationMatches[ i ].image,
 					title: objLocationMatches[ i ].title,
 					subtitle: objLocationMatches[ i ].subtitle
				} );

			} );


			// Garbarge Collection
			objLocationMatches = undefined;


			// Sort Array
			aryLocationMatches.sort( function( a, b ) {
				return a.title > b.title;
			} );


			// Callback
			callback( aryLocationMatches );

		};

	}

	function __searchSuggestion( suggestion ) {
		// console.log( "InteractiveMap: __searchSuggestion" );

		var str = '';

		str +=
			'<div>' +
				'<div class="image">';

		if ( suggestion.image )
			str += 	'<img src="' + suggestion.image + '" alt="' + suggestion.title + '">';

		str +=
			'</div>' +
				'<div class="content">' +
					'<div class="content__title">' +
						suggestion.title +
					'</div>';

		if ( suggestion.subtitle )
			str +=	'<div class="content__subtitle">' + suggestion.subtitle + '</div>';

		str +=
					'<div class="content__cta">' +
						$searchInput.data( 'suggestion-cta' ) + '<i class="webfont-arrow-long" aria-hidden="true"></i>' +
					'</div>' +
				'</div>' +
			'</div>';

		return str;

	}

	function __resize() {
		// console.log( "InteractiveMap: __resize" );

		if ( __map )
			// __map.resize();
			window.resizeMap();

	}

	function __trackEvent( category, action, label, value ) {
		// console.log( "InteractiveMap: __trackEvent", category, action, label, value );

		try {

			ga( "send", "event", category, action, label, value );

		} catch ( e ) {}

	}





	/* ----- LISTENERS ----- */
	function __onCategoryChange( e ) {
		// console.log( "InteractiveMap: __onCategoryChange" );

		var $target = $( e.currentTarget );
		var value = $target.val();

		// __offersEventsClear();
		// __newStoresClear();
		__foodDrinkClear();
		__searchCancel();

		if ( value === "clearSelect" )
			__categoryClear();
		else
			__categoryHighlight( value );

	}

	function __onKeyUp( e ) {
		// console.log( "InteractiveMap: __onKeyUp" );

		var validKeyCodes = "27 ";
			var strKeyCode = e.keyCode.toString() + " ";

			if ( validKeyCodes.indexOf( strKeyCode ) > -1 ) {

				e.preventDefault();

				switch( e.keyCode ) {

					// ESC
					case 27:
						__searchCancel();
						$searchInput.blur();
						break;

				}

			}

	}

	function __onMapData( e, data ) {
		// console.log( "InteractiveMap: __onMapData" );

		__processData( data );

	}

	function __onMapLocationOpen( e, location ) {
		// console.log( "InteractiveMap: __onMapLocationOpen" );

		__trackEvent( "map", "location-open", null, location.id );

	}

	function __onMapLocationClose( e, location ) {
		// console.log( "InteractiveMap: __onMapLocationClose" );

		__trackEvent( "map", "location-close", null, location.id );
	}

	function __onMapReady( e ) {
		// console.log( "InteractiveMap: __onMapReady" );

		__map = $mapplic.data( "mapplic" );

		__addControls();
        __addCategories();
        __showHideOffersAndNewStoresButtons();
		__addFoodDrink();

		__addLocation();

		__addSearch();

		__resize();

	}

	function __onMapTooltipLink( e, location, url ) {
		// console.log( "InteractiveMap: __onMapTooltipLink" );

		__trackEvent( "map", "external-link", null, url );

	}

	function __onMediumMediaQueryChange( list ) {
		// console.log( "InteractiveMap: __onMediumMediaQueryChange" );
		console.info( list );

		if ( list.matches )
			__map.changeDisplayMode( 1 );
		else
			__map.changeDisplayMode( 0 );

	}

	function __onOffersEventsClick( e ) {
		// console.log( "InteractiveMap: __onOffersEventsClick" );

		e.preventDefault();


		__offersEventsToggle();

	}

	function __onNewStoresClick( e ) {
		// console.log( "InteractiveMap: __onNewStoresClick" );

		e.preventDefault();


		__newStoresToggle();

	}

	function __onFoodDrinkClick( e ) {
		// console.log( "InteractiveMap: __onFoodDrinkClick" );

		e.preventDefault();

		__categoryClear();
		__searchCancel();

		__foodDrinkToggle();

	}

	function __onLocationClick( e ) {
		// console.log('ON LOCATION CLICK');
		e.preventDefault();

		var onUserLocationSuccess = function(){
			__categoryClear();
		}

		if (!!Mapplic_.geoActive){
			Mapplic_.disableUserLocation();
		}else{
			Mapplic_.requestUserLocation(onUserLocationSuccess);
		}
	}

	function _onSearchActive( e ) {
		// console.log( "InteractiveMap: _onSearchActive" );

		$controls.addClass( STYLE_SEARCH_FOCUS );
		$window.on( "keyup", __onKeyUp );

	}

	function __onSearchCancel( e ) {
		// console.log( "InteractiveMap: __onSearchCancel" );

		e.preventDefault();
		__searchCancel();

	}

	function __onSearchChange( e, value ) {
		// console.log( "InteractiveMap: __onSearchChange" );

		if ( !value )
			__searchCancel();

	}

	function __onSearchIdle( e ) {
		// console.log( "InteractiveMap: __onSearchIdle" );

		if ( $searchInput.typeahead( "val" ) === "" )
			__searchCancel();

		$window.on( "keyup", __onKeyUp );

	}

	function __onSearchRender( e ) {
		// console.log( "InteractiveMap: __onSearchRender" );

		$search.removeClass( STYLE_EMPTY );
		$searchCancel.show();

		__categoryClear();
		__offersEventsClear();
		__newStoresClear();
		__foodDrinkClear();

		__map.hideLocation();
		__map.clearHighlight();

		var ary = [];
		for ( var i = 1; i < arguments.length; i++ )
			ary.push( arguments[ i ].id );

		__map.toggleLocationHighlight( ary, true );

		// Tracking
		if ( __searchTimer )
			clearTimeout( __searchTimer );

		__searchTimer = setTimeout( __onSearchRenderTimeout, TIMEOUT_SEARCH );

	}

	function __onSearchRenderTimeout() {
		// console.log( "InteractiveMap: __onSearchRender" );

		__trackEvent( "map", "search-render", null, $searchInput.val() );

	}

	function __onSearchSelect( e, location ) {
		// console.log( "InteractiveMap: __onSearchSelect" );

		__map.clearHighlight();
		__map.showLocation( location.id );

		__trackEvent( "map", "search-select", null, location.id );

	}






	/* * * * * PUBLIC * * * * */
	// Return a constructor which returns private properties
	// and methods that should be available publically.
	return function() {
		// console.log( "new InteractiveMap" );


		/* * * * * CALL * * * * */
		// Call methods that should execute when this object
		// is instantiated.
		__init();


		return {
			init: __init,
			resize: __resize
		}
	}

}( jQuery ));

